module.exports = __webpack_public_path__ + "assets/img/one1.c1100622.png";